export default {
    parseWeekDay:(weekday)=>{
        weekday = ''+ weekday
        return weekday
          .replace('1','周一')
          .replace('2','周二')
          .replace('3','周三')
          .replace('4','周四')
          .replace('5','周五')
          .replace('6','周六')
          .replace('7','周天');
    },
    gotoStudentDetail(id,router){
      router.push({
        name: 'student_detail',
        query: {
          id: id,
        }
      })
    }
}
